import React from "react"
import Studio from "features/studio/Studio"
import MenuEditor from "features/studio/components/MenuEditor"
import WithPages from "data/wrappers/WithPages"
import PageTitle from "ui/components/PageTitle"
import Breadcrumbs from "ui/components/Breadcrumbs"

// import RecordTable from "features/studio/components/RecordTable"
import NewPageButton from "../components/NewPageButton"
import { Container, Section } from "ui"
import WithApp from "data/wrappers/WithApp"

export default class MenuPage extends React.Component {
    render() {
        return (
            <Studio color="yellow" showAppSwitcher>
                <Container marginBottom="medium" spaced>
                    <Section margin="none" padding="none">
                        <Breadcrumbs
                            crumbs={[
                                { label: "Apps", link: "/apps/" },
                                { label: "Menus", link: "" },
                            ]}
                        />
                        <PageTitle>Menus</PageTitle>
                    </Section>
                </Container>
                <WithApp appId={this.props.params.appId}>
                    {({ app, onChange }) => (
                        <WithPages>
                            {({ pages }) => (
                                <MenuEditor
                                    menu={app.options.menu}
                                    onChange={menu => {
                                        onChange({ options: { ...app.options, menu: menu } })
                                    }}
                                    pages={pages.filter(
                                        page => page.app_id === this.props.params.appId
                                    )}
                                />
                            )}
                        </WithPages>
                    )}
                </WithApp>
            </Studio>
        )
    }
}



// WEBPACK FOOTER //
// ./src/features/studio/containers/MenuPage.js